import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Theme as AugmentedTheme } from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';
import { hasAnyUrl, linkifyText } from '../utils';

interface ITitle {
    field: CustomInputMappingField
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    fieldGoupTitle: {
        fontSize: 18,
        fontWeight: 600,
        margin: 0,
    },
    linkTitle: {
        color: '#7C3AED',
    },
}))

export default function Title({field,isRtl} : ITitle) {
    const classes = useStyles();

    return(
        <h2 
        style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
        className={classes.fieldGoupTitle}>
          { hasAnyUrl(field.fieldName) ? linkifyText(field.fieldName, {linkTitle: classes.linkTitle, headerTitle: classes.fieldGoupTitle}) : field.fieldName}
        </h2>
    )
}